import {Injectable, InjectionToken} from "@angular/core";
import {lastValueFrom, takeWhile} from 'rxjs';
import {take} from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Config} from "../config/config.service";

import {Store} from "@ngrx/store";
import {AppState, selectConfigurationCore} from "../../NGRX/core.state";
import {setAllowCashBet, setLocalSettings} from "../../NGRX/configuration/configuration.actions";
import {setAppRestricted } from "../../NGRX/ui-states/ui.actions";

export const GEOLOCATION_SERVICE_TOKEN = new InjectionToken<GeolocationService>('GEOLOCATION_SERVICE_TOKEN');

@Injectable()

export abstract class GeolocationService {
  public endpoint: string;
  public xpointDisabled: boolean = false;

  constructor(public httpClient: HttpClient,
              public _config: Config,
              public store: Store<AppState>) {
    this.endpoint = _config.CONFIG.apiUrl + '/xpoint_tokens/verify';
    this.xpointDisabled = _config.CONFIG.xpointDisabled;
  }

  checkContainsUSA(obj: { name: string; id: string }): boolean {
    // Convert both name and id to lowercase and check if they include 'usa'
    const searchStr = "usa";
    return obj.name.toLowerCase().includes(searchStr) && obj.id.toLowerCase().includes(searchStr);
  }

  abstract getJurdistriction(): Promise<any>;

  abstract initPermissions(): Promise<any>;

  abstract getPermissions(): Promise<any>;

  async validateToken(token: any) {
    const params: HttpParams = new HttpParams()
      .set('xpoint_token', token);

    const request$ = this.httpClient.get(this.endpoint, {params}).pipe(take(1));
    return await lastValueFrom(request$);
  }

  parseLocation(state?: string) { // Real call site (join-registration.service.ts) passes undefined; state is unused in the body below regardless
    this.store.dispatch(setAllowCashBet({ allow_cash_bet: true }));

    this.store.select(selectConfigurationCore).pipe(
      takeWhile(data => data === undefined, true)
    ).subscribe({
      next: () => {
        /**
         * We keep the code below just in case in the future they will want
         * F2p and cash play only. To be deprecated in 1 year (july 2027)
         */

        // if (configuration) {
        //   const trimmedState = state.trim();
        //   const isCashPlayState = configuration.cash_play_enabled_states.includes(trimmedState);
        //   const isFreePlayState = configuration.free_play_only_states.includes(trimmedState);
        //
        //   if (isCashPlayState) {
        //     this.cashPlayConfig();
        //     this.store.dispatch(setAllowCashBet({ allow_cash_bet: true }));
        //   } else {
        //     this.freePlayConfig();
        //     this.store.dispatch(setAllowCashBet({ allow_cash_bet: false }));
        //
        //     if (!isFreePlayState) {
        //       this.store.dispatch(setAppRestricted({ restricted: true }));
        //     }
        //   }
        // }
      },
      error: (err) => {
        console.error("Failed to parse location (geolocation service 94). Error: ", err);
        // this.freePlayConfig();
        // this.store.dispatch(setAllowCashBet({ allow_cash_bet: false }));
        this.store.dispatch(setAppRestricted({ restricted: true }));
      }
    });
  }

  freePlayConfig() {
    const NEW_CONFIG = {
      ...(this._config.CONFIG || {}),
      enableSyndicates: false,
      haveGroupedTickets: false,
      isFreeplayOnlyMicrosite: true
    };
    this.store.dispatch(setLocalSettings({ localSettings: NEW_CONFIG }));
    this._config.CONFIG = NEW_CONFIG;
  }

  cashPlayConfig() {
    const NEW_CONFIG = {
      ...(this._config.CONFIG || {}),
      enableSyndicates: true,
      haveGroupedTickets: false,
      isFreeplayOnlyMicrosite: false
    };
    this.store.dispatch(setLocalSettings({ localSettings: NEW_CONFIG }));
    this._config.CONFIG = NEW_CONFIG;
  }
}




// import {Injectable, InjectionToken} from "@angular/core";
// import {lastValueFrom, takeWhile} from 'rxjs';
// import {take} from 'rxjs/operators';
// import {HttpClient, HttpParams} from '@angular/common/http';
// import {Config} from "../config/config.service";
//
// import {ResolveJurisdictionResponse, Xpoint} from "@xpointtech/capacitor";
// import {environment} from "@environment/environment";
// import {Store} from "@ngrx/store";
// import {AppState, selectConfigurationCore} from "../../NGRX/core.state";
// import {setAllowCashBet, setLocalSettings} from "../../NGRX/configuration/configuration.actions";
// import {Geolocation} from "@capacitor/geolocation";
// import {setAppRestricted, setLocationPermissions} from "../../NGRX/ui-states/ui.actions";
//
// export const GEOLOCATION_SERVICE_TOKEN = new InjectionToken<GeolocationService>('GEOLOCATION_SERVICE_TOKEN');
//
// @Injectable()
//
// export class GeolocationService {
//   private endpoint: string;
//   private readonly xpointDisabled: boolean = false;
//
//   constructor(private httpClient: HttpClient,
//               private _config: Config,
//               private store: Store<AppState>) {
//     this.endpoint = _config.CONFIG.apiUrl + '/xpoint_tokens/verify';
//     this.xpointDisabled = _config.CONFIG.xpointDisabled;
//   }
//
//   checkContainsUSA(obj: { name: string; id: string }): boolean {
//     // Convert both name and id to lowercase and check if they include 'usa'
//     const searchStr = "usa";
//     return obj.name.toLowerCase().includes(searchStr) && obj.id.toLowerCase().includes(searchStr);
//   }
//
//   async getJurdistriction() {
//     try {
//       return await Xpoint.resolveJurisdiction({
//         client: environment.xpointKey,
//       });
//     } catch (error) {
//       /* connection or internal error */
//     }
//   }
//
//   async validateToken(token: any) {
//     const params: HttpParams = new HttpParams()
//       .set('xpoint_token', token);
//
//     const request$ = this.httpClient.get(this.endpoint, {params}).pipe(take(1));
//     return await lastValueFrom(request$);
//   }
//
//   async initPermissions() {
//     try {
//       if (this.xpointDisabled) {
//         this.store.dispatch(setAppRestricted({restricted: false}));
//         this.store.dispatch(setLocationPermissions({location_allowed: true}))
//         return;
//       }
//       const permission = await this.getPermissions();
//
//       // Delay execution by 2 seconds
//       await new Promise(resolve => setTimeout(resolve, 2000));
//
//       const locationGranted = permission.coarseLocation === "granted" || permission.location === "granted";
//       if (locationGranted) {
//         this.store.dispatch(setLocationPermissions({location_allowed: true}))
//
//         try {
//           const jurisdictions: ResolveJurisdictionResponse = await this.getJurdistriction();
//           const isJurisdictionValid = jurisdictions?.preferableArea;
//
//           if (!isJurisdictionValid) {
//             this.store.dispatch(setAppRestricted({restricted: true}));
//           } else {
//             const appRestricted = !this.checkContainsUSA(jurisdictions.preferableArea);
//             this.store.dispatch(setAppRestricted({restricted: appRestricted}));
//           }
//         } catch (jurisdictionError) {
//           this.store.dispatch(setAppRestricted({restricted: true}));
//           console.error("Error in fetching jurisdiction:", jurisdictionError);
//         }
//       }
//     } catch (error) {
//       console.error('callLocationCheck error:', error);
//     }
//   }
//
//   async getPermissions() {
//     return await Geolocation.requestPermissions({
//       permissions: ["location"],
//     });
//   }
//
//   parseLocation(state: string) {
//     this.store.select(selectConfigurationCore).pipe(
//       takeWhile(data => data === undefined, true)
//     ).subscribe({
//       next: (configuration: any) => {
//         if (configuration) {
//           const trimmedState = state.trim();
//           const isCashPlayState = configuration.cash_play_enabled_states.includes(trimmedState);
//           const isFreePlayState = configuration.free_play_only_states.includes(trimmedState);
//
//           if (isCashPlayState) {
//             this.cashPlayConfig();
//             this.store.dispatch(setAllowCashBet({ allow_cash_bet: true }));
//           } else {
//             this.freePlayConfig();
//             this.store.dispatch(setAllowCashBet({ allow_cash_bet: false }));
//
//             if (!isFreePlayState) {
//               this.store.dispatch(setAppRestricted({ restricted: true }));
//             }
//           }
//         }
//       },
//       error: (err) => {
//         console.error("Failed to parse location (geolocation service 94). Error: ", err);
//         this.freePlayConfig();
//         this.store.dispatch(setAllowCashBet({ allow_cash_bet: false }));
//         this.store.dispatch(setAppRestricted({ restricted: true }));
//       }
//     });
//   }
//
//   freePlayConfig() {
//     const NEW_CONFIG = {
//       ...this._config.CONFIG,
//       enableSyndicates: false,
//       haveGroupedTickets: false,
//       isFreeplayOnlyMicrosite: true
//     };
//     this.store.dispatch(setLocalSettings(NEW_CONFIG));
//     this._config.CONFIG = NEW_CONFIG;
//   }
//
//   cashPlayConfig() {
//     const NEW_CONFIG = {
//       ...this._config.CONFIG,
//       enableSyndicates: true,
//       haveGroupedTickets: true,
//       isFreeplayOnlyMicrosite: false
//     };
//     this.store.dispatch(setLocalSettings(NEW_CONFIG));
//     this._config.CONFIG = NEW_CONFIG;
//   }
// }
